import DailyOutputReportPage from "./DailyOutputReportPage";

export default function DailyMigrationTeamOutputPage() {
  return (
    <DailyOutputReportPage
      title="Daily Migration Teams Output"
      label="Team"
      endpoint="/reports/daily-migration-team-output"
      detailEndpoint="/reports/daily-migration-team-output/details"
      detailParamName="team"
      exportEndpoint="/reports/daily-migration-team-output/export"
      filterEndpoint="/reports/migration-teams-list"
      filterLabel="Team"
      filterParamName="teams"
      exportFilenamePrefix="Daily_Migration_Team_Output"
    />
  );
}
